import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Router, RouterLink } from '@angular/router';
import { TranslocoPipe } from '@jsverse/transloco';
import { SavingsPlanFacade } from '@zero/saving-plans/domain';
import { ButtonComponent, IconComponent } from '@zero/shared/ui-web-design-system';
import { commonRoutes } from 'constants/web-app-constants';
import { filter } from 'rxjs';
import { OnboardingContainerComponent } from '../../components/onboarding-container/onboarding-container.component';

@Component({
  imports: [OnboardingContainerComponent, ButtonComponent, TranslocoPipe, RouterLink, IconComponent],
  templateUrl: './in-progress.component.html',
})
export class InProgressComponent implements OnInit {
  readonly #facade = inject(SavingsPlanFacade);
  readonly #router = inject(Router);
  readonly #destroyRef = inject(DestroyRef);

  public readonly maybeLaterTarget = commonRoutes.postlogin.member_home;
  public readonly nextRoute = commonRoutes.postlogin.onboarding.savingsPlan.favoriteSuggestions;

  ngOnInit(): void {
    this.#facade.loadOnboardingSavingsPlans();
    this.#facade.onboardingSavingsPlans$
      .pipe(
        filter((plans) => !!plans?.length),
        takeUntilDestroyed(this.#destroyRef),
      )
      .subscribe(() => this.#router.navigateByUrl(this.maybeLaterTarget));
  }
}
